import LogoutIcon from '@mui/icons-material/Logout';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import { useNavigate } from 'react-router-dom';
import { client } from '../app/apollo';
import { AUTH_TOKEN, LINKS, PENDING_PROMO_CODE } from '../app/constants';
import { useAppContext } from '../app/contexts/AppContext';
import { useFromMobile } from '../app/hooks/useFromMobile';

export const StepperAppBar = () => {
  const { setIsAppUserLoggedIn, setCurrentUser } = useAppContext();
  const navigate = useNavigate();
  // Only the mobile app webview hides this — it has its own native chrome.
  const fromMobile = useFromMobile();

  const logout = () => {
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.removeItem(PENDING_PROMO_CODE);
    setIsAppUserLoggedIn(false);
    navigate(LINKS.LOGIN_LINK);
    setCurrentUser(null);
    client.clearStore();
  };

  if (fromMobile) return null;

  return (
    <AppBar position="static" sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
      <Toolbar variant="dense">
        <Box display="flex" justifyContent="flex-end" alignItems="center" width="100%">
          <IconButton onClick={logout}>
            <LogoutIcon />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
